const totalDepth = 3;
const TrGroup = {
  functional: true,
  render(h, { data, props, scopedSlots }) {
    const slotDefault = scopedSlots.default ? scopedSlots.default() : [];
    const depth = data.key ? data.key.split('-').length - 1 : 1;

    const classes = data.staticClass ? data.staticClass.split(' ') : [];

    return props.list
      .filter((menu) => menu.path.length > 0 && !menu.target)
      .map((menu, idx) => {
        return [
          menu.path.length > 0
            ? h(
              'tr',
              {
                key  : data.key ? data.key : `${props.keyname}-${idx}`,
                class: [
                  {
                    hr     : !idx && props.hr,
                    comment: menu.comment ? true : false
                  }
                ].concat(classes)
              },
              Array.from({ length: depth })
                .map((item, idx) => {
                  const last = idx === depth - 1;
                  return h(
                    'td',
                    {
                      attrs: last
                        ? {
                          colspan: totalDepth + 1 - depth
                        }
                        : {}
                    },
                    last
                      ? [
                        h(
                          'router-link',
                          {
                            attrs: {
                              to: menu.path + (menu.hash || '')
                            }
                          },
                          props.deco ? props.deco + menu.name : menu.name
                        )
                      ]
                      : []
                  );
                })
                .concat(
                  h('td', {}, [
                    h(
                      'router-link',
                      {
                        attrs: {
                          to: menu.path + (menu.hash || '')
                        }
                      },
                      menu.path + (menu.hash || '')
                    )
                  ]),
                  h('td', { class: ['status'] }),
                  h('td', menu.comment)
                )
            )
            : [],
          slotDefault
        ];
      });
  },
  props: {
    list: {
      type   : Array,
      require: true
    },
    keyname: {
      type: String
    },
    hr: {
      type: Boolean
    },
    deco: {
      type: String
    }
  }
};

export default {
  layout    : 'empty',
  components: { TrGroup }
};
